import React from 'react';
import { IconProps } from '../IconProps';

export const BackArrow: React.FC<IconProps> = ({
	width = 16,
	height = 15,
	fill = 'none',
	stroke = '#171717',
	className,
}) => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 16 15"
		fill={fill}
		xmlns="http://www.w3.org/2000/svg"
		className={className}
	>
		<path
			d="M15.5 7.5H0.5"
			stroke={stroke}
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M7.5 0.5L0.5 7.5L7.5 14.5"
			stroke={stroke}
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export default BackArrow;
